import React, { useCallback, useEffect, useState } from 'react'
import { Header, Page } from 'components'

import useStyles from './styles'
import { Card, CardContent, Grid, Typography } from '@material-ui/core'

import useRouter from 'utils/useRouter'
import { useParams } from 'react-router'
import { useAnuncioService } from 'hooks/useAnuncioService'
import { BackButton } from 'components/BackButton/BackButton'

export const Anuncio = (props) => {
  const { route } = props
  const params = useParams()
  const router = useRouter()
  const classes = useStyles()
  const anuncioService = useAnuncioService()
  const [anuncio, setAnuncio] = useState(null)
  const [processando, setProcessando] = useState(true)

  const fetchAnuncio = useCallback(async () => {
    if (params.id) {
      const anuncio = await anuncioService.listarAnuncioAsync(params.id, setProcessando)
      setAnuncio(anuncio)
    }
  }, [params.id])

  useEffect(() => {
    fetchAnuncio()
  }, [fetchAnuncio])

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <Card className={classes.results}>
        <CardContent>
          {processando || !anuncio ? (
            <div>processando</div>
          ) : (
            <Grid container justifyContent="space-between">
              <Grid item md={12} sm={12} xs={12}>
                <Typography className={classes.titulo}>{anuncio.titulo}</Typography>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <Typography className={classes.resumo}>{anuncio.resumo}</Typography>
              </Grid>
              <Grid className={classes.content} item md={12} sm={12} xs={12}>
                {<div className={classes.anuncioContent} dangerouslySetInnerHTML={{ __html: anuncio.conteudo }} />}
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <BackButton />
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>
    </Page>
  )
}
